import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { ActivityTypeaheadSearchInput } from './activity-typeahead-search-input';
import { KeywordTextInput } from './keyword-text-input';

export interface ActivityKeywordSearchInputProps {
  isCarousel?: boolean;
  inDialog?: boolean;
}

export const ActivityKeywordSearchInput: React.FC<ActivityKeywordSearchInputProps> = ({ isCarousel, inDialog }) => (
  <Viewport>
    <ViewSmall>
      <Experiment name="LX_Sort_Filter_Activities_Typeahead">
        <ExperimentControl>
          <KeywordTextInput isCarousel={isCarousel} inDialog={inDialog} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <Experiment name="Optimize_Number_Of_Typeahead_Suggestion">
            <ExperimentControl>
              <ActivityTypeaheadSearchInput isCarousel={isCarousel} maxTypeaheadResults={10} />
            </ExperimentControl>
            <ExperimentVariant bucket={1}>
              <ActivityTypeaheadSearchInput isCarousel={isCarousel} maxTypeaheadResults={5} />
            </ExperimentVariant>
            <ExperimentVariant bucket={2}>
              <ActivityTypeaheadSearchInput isCarousel={isCarousel} maxTypeaheadResults={6} />
            </ExperimentVariant>
          </Experiment>
        </ExperimentVariant>
      </Experiment>
    </ViewSmall>
    <ViewMedium>
      <KeywordTextInput isCarousel={isCarousel} inDialog={inDialog} />
    </ViewMedium>
  </Viewport>
);
